export default "__VITE_ASSET__DObqyKim__"